import _ from 'lodash-extended';
import UndoController from '../../controllers/UndoController';
import app from 'app';
import storyViewBus from './storyViewBus';

export default class TimelineUndoRedoController {
  constructor(storyModel) {
    this.story = storyModel;
    this.undoController = new UndoController({
      initialState: this._prepareHistoryItem(),
    });

    this.undoController.on(
      'undo redo',
      'timeline',
      this._undoRedoHandler.bind(this)
    );
  }

  destroy() {
    this.undoController.destroy();
  }

  _prepareHistoryItem() {
    const scrollTop = app.rootStore.state.timemachine.viewOffsets.scrollTop;
    const timelineData = _.cloneDeepAndClean(this.story.getTimelineData());
    const audioTracks = _.cloneDeepAndClean(
      app.rootStore.state.story.audioTracks
    );

    return {
      component: 'timeline',
      meta: { scrollTop },
      data: {
        timelineData,
        audioTracks,
      },
    };
  }

  // zendive.timelineRedesign _resetUndoStack
  reset() {
    this.undoController.clear(this._prepareHistoryItem());
    this._updateStore();
  }

  // zendive.timelineRedesign _pushHistoryItem
  append() {
    this.undoController.push(this._prepareHistoryItem());
    this._updateStore();
  }

  // zendive.timelineRedesign _setUndoRedoState
  _updateStore() {
    app.rootStore.commit('setTimelineUndoRedo', {
      canUndo: this.undoController.canUndo(),
      canRedo: this.undoController.canRedo(),
    });
  }

  // zendive.timelineRedesign VM::[enableUndo|disableUndo]
  toggleEnable(enable) {
    if (enable) {
      this.undoController.enableKeyboard();
    } else {
      this.undoController.disableKeyboard();
    }

    app.rootStore.commit('setTimelineUndoRedo', {
      isEnabled: enable,
    });
  }

  // zendive.timelineRedesign VM::undo
  makeUndo() {
    if (app.rootStore.state.story.timelineUndoRedo.isEnabled) {
      this.undoController.undo();
    }
  }

  // zendive.timelineRedesign VM::redo
  makeRedo() {
    if (app.rootStore.state.story.timelineUndoRedo.isEnabled) {
      this.undoController.redo();
    }
  }

  _undoRedoHandler(historyItem) {
    const oldTimelineData = this.story.getTimelineData();
    const neededRtpChecksums = new Set();

    _.each(historyItem.data.visualTracks, (visualTrack) => {
      if (!visualTrack.realTimePreviewResultData) {
        neededRtpChecksums.add(
          app.generateAssetRealTimeChecksum({
            visualTrack: visualTrack,
            aspectRatio: this.story.get('aspectRatio'),
            themeOverrides: app.rootStore.getters.themeOverrides,
          })
        );
      }
    });

    // abort unneeded rtps
    _.each(oldTimelineData.visualTracks, (visualTrack) => {
      const tmpChecksum = app.generateAssetRealTimeChecksum({
        visualTrack: visualTrack,
        aspectRatio: this.story.get('aspectRatio'),
        themeOverrides: app.rootStore.getters.themeOverrides,
      });
      if (tmpChecksum && !neededRtpChecksums.has(tmpChecksum)) {
        app.resetVisualTrackRTP(visualTrack);
      }
    });

    storyViewBus.$emit('svbPauseRcp');
    const seekToTime = app.rootStore.state.timemachine.secondhand;
    this._updateStore();
    this.story.set(
      'timelineData',
      _.cloneDeepAndClean(historyItem.data.timelineData)
    );
    app.rootStore.commit('setAudioTracks', historyItem.data.audioTracks);
    app.rootStore.dispatch('UNDELETE_VOICEOVER_SEGMENTS');

    storyViewBus.$emit('svbTimelineUpdate', historyItem.meta, () => {
      app.timelineGateway.serializeTimelineDebounced();
      storyViewBus.$emit('svbSeekRcp', seekToTime);
      app.timelineGateway.initRtpLookup({ resetRTP: false });
    });
  }
}
